import styles from './styles.module.scss'
 
type props = {
    texto?: string;
    id?: string;
    onClick?: any;
    isLogicMaker: boolean
    css: any;
    pos?: {x : number,y: number}
    size?: {x : number,y: number}
}

export default function CustomText({texto,id,onClick,isLogicMaker,css,pos,size} : props) {
     pos = pos || {x:0,y:0}
     size = size || {x:0,y:0}

    return (
         <div
                            id={id}
                            className={styles.texto}
                            onClick={onClick}
                            style={{
                                position: isLogicMaker? 'relative' : 'fixed',
                                cursor: 'move',
                                width: isLogicMaker? '100%': size.x,
                                height: isLogicMaker?'100%': size.y,
                                left: !isLogicMaker? pos.x *window.innerWidth: undefined,
                                top: !isLogicMaker? pos.y *window.innerHeight : undefined,
                                ...css,
                                
                        
                                
                            }}
                        >
                            {texto}
                            </div>
                )
                    }
 
